import type { CSSProperties, FunctionComponent } from 'react';
import type { TypeListProps } from './types';

/**
 * List
 * Bullet del Hero: usa el SVG configurado en Strapi (theme-configuration →
 * bulleticon, descargado por theme-config.js a
 * /public/assets/images/bullet-icon.svg) como `mask` para que tome el color
 * actual del texto. Mismo patrón que en `Prose.module.css`.
 */
const BULLET_MASK_STYLE: CSSProperties = {
  maskImage: "url('/assets/images/bullet-icon.svg')",
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  maskSize: 'contain',
  WebkitMaskImage: "url('/assets/images/bullet-icon.svg')",
  WebkitMaskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  WebkitMaskSize: 'contain',
};

export const List: FunctionComponent<TypeListProps> = ({
  className = '',
  items,
}: TypeListProps) => (
  <div
    className={`text-body text-body-l text-neutrals-0 mb-8 flex flex-col gap-3 md:w-[590px] ${className}`}
  >
    {items.map((item, index: number) => (
      <div className="flex items-center gap-3" key={index}>
        <span
          aria-hidden
          className="block h-4 w-4 shrink-0 bg-current"
          style={BULLET_MASK_STYLE}
        />
        <span>{item}</span>
      </div>
    ))}
  </div>
);

List.displayName = 'List';
